/**
 * transformer.service.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Injectable } from "@angular/core";

import { IntakeControlBuilder }
    from "../../../intake-form/control.builder";
import { AlgorithmStep, IntakeStep, ReportStep } from "../../structure/";

import { Autofiller } from "./autofiller";
import { Categorizer } from "./categorizer";
import { DeveloperStepDisabler } from "./developer-step-disabler";
import { HintCategoryExtractor } from "./hint-category-extractor";
import { StepTransformer, TransformerEffects }
    from "./step-transformer";

@Injectable()
export class TransformerService
{
    public enabled : StepTransformer[];

    public readonly supportedTypes : any[] = [IntakeStep, ReportStep];

    public byType : Map<any, StepTransformer[]> =
        new Map<any, StepTransformer[]>();

    constructor (
        public autofiller : Autofiller,
        public categorizer : Categorizer,
        public controlBuilder : IntakeControlBuilder,
        public devDisabler : DeveloperStepDisabler,
        public hintExtractor : HintCategoryExtractor
    )
    {
        // init
        this.enabled = [
            autofiller,
            categorizer,
            controlBuilder,
            devDisabler,
            hintExtractor
        ];
        this.enabled.sort(
            (a : StepTransformer, b : StepTransformer) => a.order - b.order);
        console.info("Available transformers:", this.enabled);

        this.supportedTypes.forEach(
            (type : any) => this.byType.set(
                type,
                this.enabled.filter(
                    (t : StepTransformer) => t.matchesType(type))));
    }

    public run (step : AlgorithmStep, create : boolean = false)
        : TransformerEffects
    {
        const type : any = this.supportedTypes.find(
            (possible : any) => step instanceof possible);
        if (type === undefined) {
            console.error(step);
            throw new Error("Could not find an appropriate type for step");
        }

        const flags : TransformerEffects = {};
        this.byType.get(type).forEach((t : StepTransformer) => {
            Object.assign(
                flags,
                (create ? t.create(step) : t.apply(step))
            );
        });

        return flags;
    }
}

export const STEP_TRANSFORMER_LIST : any[] = [
    Autofiller,
    Categorizer,
    DeveloperStepDisabler,
    HintCategoryExtractor,
    IntakeControlBuilder
];



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/management/pipeline/transformer.service.ts